export default [
    {
        path: '/icon-overview',
        name: 'icon-overview',
        component: () => import('@src/development/icon-overview'),
        meta: {
            title: 'Icons',
            role: 'ROLE_ROOT',
        },
    },
    {
        path: '/sandbox',
        name: 'sandbox',
        component: () => import('@src/development/sandbox'),
        meta: {
            title: 'Sandbox',
            role: 'ROLE_ROOT',
        },
    },
];
